module.exports = __webpack_public_path__ + "006f11137bc1c94988cdb018e583d957.svg";